import { omit } from 'lodash'
import { combineReducers } from 'redux'
import { getType } from 'typesafe-actions'

import {
  analyzeDealSuccess,
  DealAction,
  deleteDeal,
  fetchOneDealAsUser,
  markDealAsNew,
  setDeals,
  setOneDeal,
  triggerDealReanalysisSuccess,
  updateDealInfoSuccess,
} from './actions'
import { DealsState } from './types'

export const dealsReducer = combineReducers<DealsState, DealAction>({
  isFetching: (isFetching = false, action) => {
    switch (action.type) {
      default:
        return isFetching
    }
  },
  items: (deals = {}, action) => {
    switch (action.type) {
      case getType(setDeals):
        return action.payload
      case getType(fetchOneDealAsUser.success):
      case getType(setOneDeal):
      case getType(triggerDealReanalysisSuccess):
      case getType(analyzeDealSuccess):
      case getType(updateDealInfoSuccess):
      case getType(markDealAsNew.success): {
        const { id } = action.payload
        return {
          ...deals,
          [id]: action.payload,
        }
      }
      case getType(deleteDeal.success): {
        const dealId = action.payload
        return omit(deals, dealId)
      }
      default:
        return deals
    }
  },
})
